import { useEffect, useState } from 'react'
import { useAuth } from './useAuth'
import { getDocument, typedDoc } from '@/lib/firebase/firestore'
import type { UserDocument } from '@/types'

export function useUserRole() {
  const { user, loading: authLoading } = useAuth()
  const [role, setRole] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (authLoading) return
    if (!user) {
      setRole(null)
      setLoading(false)
      return
    }
    const ref = typedDoc<UserDocument>('users', user.uid)
    getDocument(ref)
      .then((doc) => setRole(doc?.role ?? 'user'))
      .catch(() => setRole('user'))
      .finally(() => setLoading(false))
  }, [user, authLoading])

  return {
    role,
    isAdmin: role === 'admin',
    isDesigner: role === 'designer',
    isStaff: role === 'staff',
    canDesign: role === 'admin' || role === 'designer',
    loading,
  }
}
